import { defineComponent, ref, computed, watch, onMounted, nextTick, onBeforeUnmount } from "vue";
import throttle from "./component-library151.mjs";
import GoliathImageElement from "./component-library18.mjs";
import Arrow from "./component-library4.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "image-gallery-2023",
  props: {
    images: { default: void 0 },
    initialSelectedIndex: { default: 0 },
    noZoom: { type: Boolean },
    thumbnailLabel: { default: "Bilder auswählen" },
    textZoom: { default: "Vergrößern" },
    textSelectImage: { default: "Bild Anzeigen" },
    textControlGroup: { default: "Bilder Navigation" },
    textPrevControl: { default: "Vorheriges Bild" },
    textNextControl: { default: "Nächstes Bild" }
  },
  emits: ["zoom", "selected-image"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const selectedImageIndex = ref(props.initialSelectedIndex);
    const showScrollUpButton = ref(false);
    const showScrollDownButton = ref(false);
    const thumbnailsContainerElement = ref(null);
    const imageCount = computed(() => {
      var _a;
      return ((_a = props.images) == null ? void 0 : _a.length) || 0;
    });
    const hasMultipleImages = computed(() => imageCount.value > 1);
    const selectedImage = computed(
      () => {
        var _a;
        return (_a = props.images) == null ? void 0 : _a[selectedImageIndex.value];
      }
    );
    const selectImage = (index) => {
      if (index >= imageCount.value) {
        selectedImageIndex.value = 0;
        return;
      }
      if (index < 0) {
        selectedImageIndex.value = imageCount.value - 1;
        return;
      }
      selectedImageIndex.value = index;
    };
    const incrementSelectedImageIndex = () => {
      selectImage(selectedImageIndex.value + 1);
    };
    const decrementSelectedImageIndex = () => {
      selectImage(selectedImageIndex.value - 1);
    };
    const emitClick = () => {
      if (!props.noZoom) {
        emit("zoom", {
          zoomParams: props.textZoom.toLowerCase(),
          selectedImageIndex: selectedImageIndex.value,
          selectedImage: selectedImage.value
        });
      }
    };
    const handleScroll = () => {
      if (!thumbnailsContainerElement.value)
        return;
      const isFullyScrolled = Math.abs(
        thumbnailsContainerElement.value.scrollHeight - thumbnailsContainerElement.value.scrollTop - thumbnailsContainerElement.value.clientHeight
      ) < 3;
      showScrollUpButton.value = thumbnailsContainerElement.value.scrollTop !== 0;
      showScrollDownButton.value = !isFullyScrolled;
    };
    const onScroll = throttle(handleScroll, 200);
    const scrollUp = () => {
      if (!thumbnailsContainerElement.value)
        return;
      thumbnailsContainerElement.value.scrollTop -= thumbnailsContainerElement.value.clientHeight;
    };
    const scrollDown = () => {
      if (!thumbnailsContainerElement.value)
        return;
      thumbnailsContainerElement.value.scrollTop += thumbnailsContainerElement.value.clientHeight;
    };
    watch(
      () => props.initialSelectedIndex,
      (newIndex) => {
        selectImage(newIndex);
      }
    );
    watch(
      () => props.images,
      () => {
        selectedImageIndex.value = 0;
        selectImage(0);
      }
    );
    watch(selectedImage, (value) => {
      if (!value)
        return;
      emit("selected-image", value);
    });
    onMounted(() => {
      if (!hasMultipleImages.value)
        return;
      nextTick(() => {
        setTimeout(() => {
        }, 500);
      });
    });
    onBeforeUnmount(() => {
      var _a;
      (_a = thumbnailsContainerElement.value) == null ? void 0 : _a.addEventListener("scroll", onScroll);
    });
    expose({
      incrementSelectedImageIndex,
      decrementSelectedImageIndex,
      selectedImageIndex,
      selectedImage,
      selectImage,
      imageCount,
      hasMultipleImages,
      emitClick
    });
    return { __sfc: true, props, emit, selectedImageIndex, showScrollUpButton, showScrollDownButton, thumbnailsContainerElement, imageCount, hasMultipleImages, selectedImage, selectImage, incrementSelectedImageIndex, decrementSelectedImageIndex, emitClick, handleScroll, onScroll, scrollUp, scrollDown, GoliathImageElement, Arrow, LinkButton };
  }
});
export {
  _sfc_main as default
};
